import { useEffect } from 'react'

function useBaseFontSize() {
  // Set the base font size based on the window width
  function setBaseFont() {
    const baseFontSize = (100 / 375) * window.innerWidth
    document.documentElement.style.setProperty('font-size', `${baseFontSize}px`, 'important')
  }

  setBaseFont()
  // Set the base font size when the component mounts
  useEffect(() => {
    window.addEventListener('resize', setBaseFont)
    return () => {
      window.removeEventListener('resize', setBaseFont)
    }
  }, [])

}

export default useBaseFontSize